import { Component, OnInit, AfterViewInit, Input } from '@angular/core';
import { LoadingOverlayService } from '../../service/loading-overlay.service';
import { AnimationOptions } from 'ngx-lottie';

@Component({
  selector: 'app-loading-overlay',
  templateUrl: './loading-overlay.component.html',
  styleUrls: ['./loading-overlay.component.scss']
})
export class LoadingOverlayComponent implements OnInit {

  partnerCode: any;
  

  constructor(
    public loadingService: LoadingOverlayService,
  ) { }

  ngOnInit(): void {
    let urlParams = new URLSearchParams(window.location.search);
    this.partnerCode = urlParams.get("partnerCode");
  }
  
  animationOptions: AnimationOptions = {
    path: '../../assets/animations/ps_loading_animation.json', // Path to your animation JSON file
  };

  animationOptionsProlindung: AnimationOptions = {
    path: '../../assets/animations/kopetro_loading_animation.json', // Path to your animation JSON file
  };
}
